import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import styled from 'styled-components'

const TimePicker = ({}) => {
  const options = [
    { value: '00', label: '임시 휴무일' },
    { value: '01', label: '기상 악화' },
    { value: '02', label: '가게 사정' },
    { value: '03', label: '조기 마감' },
    { value: '04', label: '메뉴 품절' },
    { value: '05', label: '기타' },
  ]

  const periodOptions = [
    { value: 'AM', label: '오전' },
    { value: 'PM', label: '오후' },
  ]
  return (
    <div className="">
      <SelectOptions
        options={options}
        placeholder="사유 선택"
        noOptionsMessage={() => '사유 선택해주세요'}
      />
    </div>
  )
}
export default TimePicker

const SelectOptions = styled(Select)`
  .css-tr4s17-option {
    background-color: #eef3e4;
    color: black;
  }
  .css-t3ipsp-control:hover,
  .css-t3ipsp-control:not(:hover) {
    border-color: gray;
    box-shadow: none;
  }
  .css-16xfy0z-control,
  .css-t3ipsp-control,
  .css-13cymwt-control {
    width: 100%;
    height: 36px;
  }
  .css-d7l1ni-option {
    background-color: white;
  }
  .css-d7l1ni-option:hover {
    background-color: #eef3e4;
  }
  .css-1u9des2-indicatorSeparator {
    width: 0px;
  }
  @media ${(props) => props.theme.mobile} {
    .css-1nmdiq5-menu {
      font-size: 14px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: left;
      color: #000;
    }
  }
`
